import styled from "@emotion/styled";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { Loader, Typography } from "@kaltura/ds-react-components";

const StyledContainer = styled("div")(({ theme }) => ({
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    textAlign: "center",
    backgroundColor: theme.kaltura.palette.primary.main,
    color: theme.kaltura.palette.primary.contrastText,
    borderRadius: theme.kaltura.shape.roundness2,
}));

const StyledLoaderContainer = styled("div")({
    width: 40,
    height: 40,
});

/**
 * in place uploader processing indicator
 */
export const UploadProcessingIndicator = () => {
    return (
        <StyledContainer>
            <StyledLoaderContainer>
                <Loader variant="white" size="large" />
            </StyledLoaderContainer>
            <Typography variant={"h5"} component="div">
                {translate("Processing")}
            </Typography>
        </StyledContainer>
    );
};
